// extracted by mini-css-extract-plugin
module.exports = {"header":"header-module--header--tFeG9","logo":"header-module--logo--2kX-3"};